import React, { useState, useRef, useEffect } from "react";
import { useLocation,Link } from "react-router-dom";
import "../../styles/MenuBar.css";
import "./menuBarLoggedIn.js"
import bell from "../../assets/svgs/bell.svg"


export const MenuBar = () => {
//   const [isOpen, setIsOpen] = useState(false);
const navbarRef = useRef(null);

let location = useLocation();

const [navbar,setNavBar] = React.useState(false)

// Close the navbar when clicking outside of it
useEffect(() => {
  function handleClickOutside(event) {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      // setIsOpen(false);
      setNavBar(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [navbarRef]);
  return (
    <>
        <header  ref={navbarRef} className={`primary-header ${location.pathname === "/" || location.pathname === "/faq" ? "home-nav" : ""}`}>
            {/* <header className="primary-header-wrapper"> */}
                <div>
                    <a className="logo" href="/">Shuttle <span style={{ color: "#049F5A" }}>9<span style={{ color: "#A6B501" }}>j</span>a</span></a>
                </div>
                <button className={`mobile-nav-toggle ${navbar ? 'open' : 'close'}`}
                onClick={() => {
                    //  setIsOpen(!isOpen);
                     setNavBar((prevState) => !prevState)}}
                // eslint-disable-next-line jsx-a11y/aria-proptypes
                aria-controls="primary-navigation" aria-expanded = {`${navbar ? true : false}`}>
                    <span className="sr-only">Menu</span>
                    <div className="hamburger">
                      <div className="hamburger-top"></div>
                      <div className="hamburger-middle"></div>
                      <div className="hamburger-bottom"></div>
                    </div>
                </button>
                <nav ref={navbarRef}>
                    <ul ref={navbarRef} className = {`primary-navigation ${navbar ? 'open' : 'close'}`}>
                    <li className={location.pathname === "/" ? "active" : ""}>
                        <Link to ="/">Home</Link>
                    </li>
                    <li className={location.pathname === "/about" ? "active" : ""}>
                        <Link to="/about">About</Link>
                    </li>
                    <li className={location.pathname === "/transco" ? "active" : ""}>
                        < Link to="/transco">Transcos</Link>
                    </li>
                    <li className={location.pathname === "/faq" ? "active" : ""}>
                        <Link to ="/faq">FAQ</Link>
                    </li>
                    <li className={location.pathname === "/contact" ? "active" : ""}>
                        < Link to="/contact">Contact</Link>
                    </li>
                    </ul>
                </nav>
                <div className = {`nav-side-bar ${navbar ? 'open' : 'close'}`}>
                    <div className="notifications">
                        <img src={bell} alt="bell icon" />
                    </div>
                    <Link to="/account-overview" className = "account">
                        <p>A</p>
                    </Link>
                </div>
            {/* </header> */}
        </header>
    </>
  );
};

export default MenuBar;